export default __webpack_public_path__ + "static/media/graphic-13.ba362798.png";